import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import useGruposUnidades from "core/features/grupo-unidades/hooks/useGruposUnidades";
import { useState, useEffect } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import ModalGrupoUnidade from "./ModalGrupoUnidade";
export interface SelectGrupoUnidadeProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any, option?: any) => void;
  isInvalid?: boolean;
  filteredOptions?: string[];
  incluirUnidades?: string;
}

function SelectGrupoUnidade({
  value,
  onChange,
  isInvalid,
  filteredOptions,
  incluirUnidades,
  ...rest
}: SelectGrupoUnidadeProps) {
  const { isLoading, isFetching, data } = useGruposUnidades({
    incluirUnidades,
    id: value && typeof value === "string" ? value : undefined,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
    }
  }, [isOpenModal]);

  return (
    <>
      {isOpenModal ? (
        <ModalGrupoUnidade
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          defaultValue={{ nome: search }}
          onSuccess={(result) => {
            onChange(result.id);
            data?.push(result);
          }}
        />
      ) : null}

      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        size="large"
        placeholder="Selecione o grupo de unidade"
        value={value || undefined}
        onChange={onChange}
        allowClear
        {...rest}
        showSearch
        searchValue={search}
        onSearch={(v) => {
          if (!isOpenModal) {
            setSearch(v);
          }
        }}
        optionFilterProp="label"
        options={data
          ?.filter((item) =>
            filteredOptions ? !filteredOptions.includes(item.id) : true
          )
          .map((item) => ({
            value: item.id,
            label: item.nome,
            unidades: item.unidades,
          }))
          .sort((a, b) => {
            const isASelected = Array.isArray(value)
              ? value.includes(a.value)
              : a.value === value;
            const isBSelected = Array.isArray(value)
              ? value.includes(b.value)
              : b.value === value;

            if (isASelected && !isBSelected) return -1;
            if (!isASelected && isBSelected) return 1;
            return 0;
          })}
        notFoundContent={
          <Box>
            Nada encontrado!!{" "}
            <Button
              leftIcon={<i className="mdi mdi-plus" />}
              size="xs"
              colorScheme="orange"
              onClick={() => setIsOpenModal(true)}
            >
              cadastrar novo
            </Button>
          </Box>
        }
      />
    </>
  );
}

export default SelectGrupoUnidade;
